import { usePostFetchAuthenticate } from "hooks";
import { getURLWithParams } from "utils/context";

export const useLawsRegimes = (params = {}) =>
  usePostFetchAuthenticate(getURLWithParams("/laws/regime", params));
